import { render, staticRenderFns } from "./QuestionInfo.vue?vue&type=template&id=40e1f35f&scoped=true&"
import script from "./QuestionInfo.vue?vue&type=script&lang=ts&"
export * from "./QuestionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionInfo.vue?vue&type=style&index=0&id=40e1f35f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e1f35f",
  null
  
)

export default component.exports